<template>
  <div>
    <div v-if="matchInfo.isShowGame === 'SHOW'">
      <BigGame v-if="matchInfo && matchInfo.joinChannel === 'bigball'"/>
      <DefaultGame v-else/>
    </div>
    <div class="content" style="margin-top: 50px;height: 100px;" v-else>
      <a-empty
        :image="hiddenImg"
        :image-style="{height: '30px'}">
        <span slot="description" style="color:#bbbaba;">
          <!-- 主办方隐藏了场次对战 -->
        </span>
      </a-empty>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import matchFun from '@comm/utils/matchFun'
import BigGame from './modal/BigGame'
import DefaultGame from './modal/DefaultGame'
export default {
  name: 'MatchGame',
  components: {
    DefaultGame,
    BigGame
  },
  created () {
    this.findData()
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      matchFun: matchFun,
      hiddenImg: require('../assets/hidden.png')
    }
  },
  computed: {
    ...mapState({
      matchInfo: state => state.match.matchInfo
    })
  },
  methods: {
    findData () {
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/comm/components/MatchGame.vue